<p-confirmDialog></p-confirmDialog>
<div class="coordinator-view" 
     [class.fullscreen]="isFullscreen">
  <!-- Main Video Area -->
  <div class="main-video-area">
    <!-- Video Content Section (Video + Controls) -->
    <div class="video-content-section" [class.chat-visible]="isSessionStarted">
      <!-- Inspector/Guest Video (Main Area) -->
      <div class="inspector-video-container" [class.photo-flash]="isCapturingPhoto">
        <video-player-container #inspectorVideoContainer></video-player-container>
      
      <!-- Floating Coordinator Video (Top Right) -->
      <div class="coordinator-video-overlay" 
           [class.hidden]="!showCoordinatorVideo || !isSessionStarted">
        <video #coordinatorVideo 
               autoplay 
               playsinline
               muted="false"
               controls="false"
               class="coordinator-video"
               style="width: 100%; height: 100%; object-fit: cover; background: #333;"></video>
        <button class="close-coordinator-btn" 
                *ngIf="isSessionStarted"
                (click)="toggleCoordinatorVideo()"
                [pTooltip]="coordinatorVideoActive ? 'Turn off camera' : 'Hide self-view'"
                tooltipPosition="left">
          <i class="pi pi-times"></i>
        </button>
      </div>
      
      <!-- Hidden Coordinator Toggle Icon -->
      <button class="show-coordinator-btn" 
              *ngIf="!showCoordinatorVideo && isSessionStarted"
              (click)="toggleCoordinatorVideo()"
              [pTooltip]="coordinatorVideoActive ? 'Show self-view' : 'Turn on camera'"
              tooltipPosition="left">
        <i class="pi pi-video"></i>
      </button>
      
      <!-- Network Quality Indicator with Location Icon -->
      <app-network-quality-indicator
        *ngIf="isSessionStarted"
        class="network-quality-overlay"
        [quality]="networkQuality"
        [trend]="networkTrend"
        [latency]="networkLatency"
        [locationActive]="locationTrackingActive"
        (locationClick)="openLocationDialog()">
      </app-network-quality-indicator>
      
      <!-- Floating Session Controls (Bottom Center) -->
      <div class="floating-controls" *ngIf="isSessionStarted">
        <!-- Primary Controls -->
        <div class="primary-controls">
          <button class="control-btn record-btn"
                  *ngIf="isInspectorConnected"
                  (click)="record($event)"
                  [class.active]="isRecording"
                  [pTooltip]="isRecording ? 'Stop Recording' : 'Start Recording'"
                  tooltipPosition="top">
            <i class="pi" [class.pi-circle]="!isRecording" [class.pi-stop-circle]="isRecording"></i>
          </button>
          
          <button class="control-btn photo-btn"
                  *ngIf="shouldShowPhotoButton"
                  (click)="takePhoto($event)"
                  [disabled]="isCapturingPhoto"
                  [pTooltip]="isCapturingPhoto ? 'Capturing Photo...' : 'Take Photo'"
                  tooltipPosition="top"
                  [class.capturing]="isCapturingPhoto">
            <i *ngIf="!isCapturingPhoto" class="pi pi-camera"></i>
            <i *ngIf="isCapturingPhoto" class="pi pi-spin pi-spinner"></i>
          </button>
          
          <button class="control-btn thumbnails-btn"
                  (click)="toggleThumbnailDrawer()"
                  [class.active]="showThumbnailDrawer"
                  pTooltip="Toggle Thumbnails"
                  tooltipPosition="top">
            <i class="pi pi-th-large"></i>
          </button>
          
          <button class="control-btn gallery-btn"
                  (click)="openMediaGalleryDialog()"
                  pTooltip="Open Full Media Gallery"
                  tooltipPosition="top">
            <i class="pi pi-images"></i>
          </button>
          
          <button class="control-btn settings-btn"
                  (click)="toggleDeviceSettings()"
                  [class.active]="showDeviceSettings"
                  pTooltip="Device Settings"
                  tooltipPosition="top">
            <i class="pi pi-cog"></i>
          </button>
          
                  <button class="control-btn share-btn"
                          (click)="openGuestLinkDialog()"
                          pTooltip="Share Guest Link"
                          tooltipPosition="top">
                    <i class="pi pi-share-alt"></i>
                  </button>
                  
                  <button class="control-btn chat-btn"
                          (click)="toggleChat()"
                          [class.active]="showChat"
                          pTooltip="Toggle Chat"
                          tooltipPosition="top">
                    <i class="pi pi-comments"></i>
                    <span class="control-badge" *ngIf="((chatService.unreadCount$ | async) || 0) > 0 && !showChat">
                      {{ (chatService.unreadCount$ | async) || 0 }}
                    </span>
                  </button>
                  
                  <button class="control-btn end-btn"
                          (click)="endSession($event)"
                          pTooltip="End Session"
                          tooltipPosition="top">
                    <i class="pi pi-sign-out"></i>
                  </button>
        </div>
      </div>
      
        <!-- Pre-session Controls -->
        <div class="pre-session-controls" *ngIf="!isSessionStarted">
          <button class="start-session-btn" 
                  *ngIf="isMediaNetworkConnected"
                  (click)="startSession($event)"
                  [disabled]="!isMediaNetworkConnected || isSessionStarting">
            <i class="pi pi-play"></i>
            <span>Start Session</span>
          </button>
          <button class="close-btn" 
                  (click)="endSession($event)">
            <i class="pi pi-times"></i>
            <span>Close</span>
          </button>
        </div>
      </div>
    </div>
    
            <!-- Chat Section (Reserved Space at Bottom) -->
            <div class="chat-section" *ngIf="isSessionStarted && showChat">
              <app-chat></app-chat>
            </div>
  </div>
  
  <!-- Thumbnail Drawer Toggle Button (Left Edge) -->
  <button class="thumbnail-drawer-handle" 
          *ngIf="!showThumbnailDrawer && isSessionStarted"
          (click)="toggleThumbnailDrawer()"
          pTooltip="Show Captured Photos"
          tooltipPosition="right">
    <i class="pi pi-chevron-right"></i>
    <span class="media-count-badge" *ngIf="(sessionPhotos$ | async)?.length">
      {{ (sessionPhotos$ | async)?.length }}
    </span>
  </button>
  
  <!-- Thumbnail Drawer -->
  <app-media-thumbnail-drawer
    [media]="(sessionPhotos$ | async) ?? []"
    [isVisible]="showThumbnailDrawer && isSessionStarted"
    [isPinned]="isThumbnailDrawerPinned"
    (closeDrawer)="closeThumbnailDrawer()"
    (openFullGallery)="openMediaGalleryDialog()"
    (capturePhoto)="takePhoto($event)"
    (pinToggled)="onThumbnailDrawerPinToggled($event)"
    (mouseLeave)="onDrawerMouseLeave()">
  </app-media-thumbnail-drawer>
  
  <!-- Device Selection Overlays (Hidden by default, shown via settings) -->
  <div class="device-selection-overlay" 
       [class.visible]="showDeviceSettings"
       *ngIf="isSessionStarted">
    <div class="device-controls">
      <div class="device-header">
        <h4>Device Settings</h4>
        <button class="close-settings-btn" 
                (click)="toggleDeviceSettings()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <p-select *ngIf="micDevices.length" 
                  [options]="micDevices" 
                  (onChange)="selectMic($event)" 
                  [(ngModel)]="selectedMic" 
                  placeholder="Select Microphone"
                  name="mics"></p-select>
      <p-select *ngIf="speakerDevices.length" 
                  [options]="speakerDevices" 
                  (onChange)="selectSpeaker($event)" 
                  [(ngModel)]="selectedSpeaker" 
                  placeholder="Select Speaker"
                  name="speakers"></p-select>
      <p-button *ngIf="isInspectorConnected && !inspectorCameraList?.length"
                label="Get Inspector Cameras"
                icon="pi pi-video"
                (onClick)="getInspectorCameraList($event)"
                severity="secondary"></p-button>
      <p-select *ngIf="inspectorCameraList?.length" 
                  [options]="inspectorCameraList || []" 
                  [optionLabel]="'label'" 
                  [optionValue]="'deviceId'" 
                  (onChange)="selectInspectorCamera($event)" 
                  [(ngModel)]="selectedInspectorCamera" 
                  placeholder="Select Inspector Camera"
                  name="inspector-cameras"></p-select>
    </div>
  </div>
  
  <!-- Guest Link Dialog -->
  <app-guest-link-dialog
    [(visible)]="showGuestLinkDialog"
    [session]="guestLinkSession">
  </app-guest-link-dialog>

  <!-- Location Map Dialog -->
  <app-location-map-dialog
    [(visible)]="showLocationDialog"
    [sessionId]="sessionId">
  </app-location-map-dialog>
</div>

<!-- Full Media Gallery Dialog (Outside coordinator-view for proper z-index) -->
<p-dialog 
  header="Media Gallery" 
  [(visible)]="showMediaGalleryDialog" 
  [modal]="true" 
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [baseZIndex]="1100"
  [style]="{width: '90vw', maxWidth: '1200px', height: '85vh'}"
  styleClass="media-gallery-dialog">
  
  <div class="media-gallery-dialog-content">
    <app-media-gallery
      *ngIf="showMediaGalleryDialog"
      [sessionId]="sessionId"
      [media]="(sessionMedia$ | async) ?? []"
      [isCoordinator]="true"
      [showControls]="true"
      (mediaCaptureRequested)="onPhotoCaptureRequested()"
      (mediaAdded)="onMediaAdded($event)"
      (mediaDeleted)="onMediaDeleted($event)">
    </app-media-gallery>
  </div>
</p-dialog>
